export default {
  messages: {
    en: {
      approvedAt: 'Loan added:',
    },
  },
}
